import { WorkspaceT } from '@/pages/workgroup/type';
import { compare } from 'compare-versions';

export const supportQueryProfile = (wp: WorkspaceT | undefined) => {
  return !!wp?.tg_version && compare(wp?.tg_version, '4.1.x', '>');
};
